import React from "react";
import { Feather } from "@expo/vector-icons";
import shieldIcon from "../../../assets/shield-check.png";
import indiaFlag from "../../../assets/flag-india.png";

export default function DossierHeader({ goBack }) {
  return (
    <>
      <div className="pdh-header">
        <div className="pdh-topbar">
          <div className="pdh-brand">
            <img src={shieldIcon} alt="logo" className="pdh-logo" />
            <div className="pdh-brand-texts">
              <h1>Dossier produit / producteur</h1>
              <p>CORRIDOR DE CONFORMITÉ • TIKO / IDÉNAU</p>
            </div>
          </div>

          <div className="pdh-top-actions">
            <div className="pdh-nav-pill">
              <span className="active">CLD</span>
              <span>Turelo</span>
              <span>Sanctions</span>
              <span className="pdh-nav-caret">▾</span>
            </div>

            <button className="pdh-icon-btn" aria-label="Notifications">
              ⌂
            </button>

            <button className="pdh-icon-btn" aria-label="Settings">
              ⚙
            </button>
          </div>
        </div>

        <div className="pdh-divider" />

        <div className="pdh-main">
          <div className="pdh-left">
            <h2>Chaussures de sécurité</h2>

            <div className="pdh-subline">
              Famille : Footwear / Chaussures
            </div>

            <div className="pdh-producer-line">
              <span>Producteur : Yikodeen</span>
              <span className="pdh-status">Valide</span>
            </div>

            <div className="pdh-meta-line">
              <span>Pays d'origine : Inde</span>
              <img src={indiaFlag} alt="Inde" className="pdh-flag-img" />
            </div>

            <div className="pdh-meta-line pdh-reference-line">
              <span>Référence dossier produit :</span>
              <strong>PP-TKO-03705</strong>
            </div>
          </div>

          <div className="pdh-right">
            <button className="pdh-action-btn">↗ Partager</button>
            <button className="pdh-action-btn">⌕ / Hitorique</button>
            <button className="pdh-action-btn">✉ Options...▾</button>
            <button
  className="pdh-action-btn pdh-action-btn-small"
  onClick={goBack}
  aria-label="Réduire"
>
  <Feather name="chevron-up" size={16} color="#E7EDFF" />
</button>
          </div>
        </div>
      </div>

      <style>{`
        .pdh-header {
          position: relative;
          padding: 16px 18px 18px;
          border-radius: 24px;
          background:
            radial-gradient(circle at top left, rgba(82,112,255,0.12), transparent 22%),
            linear-gradient(180deg, rgba(20,28,62,0.98), rgba(11,20,48,0.98));
          border: 1px solid rgba(255,255,255,0.08);
          box-shadow: 0 18px 40px rgba(0,0,0,0.28);
          overflow: hidden;
          font-family: "Manrope", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        }

        .pdh-header::before {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: linear-gradient(
            135deg,
            rgba(255,255,255,0.035) 0%,
            rgba(255,255,255,0.01) 45%,
            rgba(255,255,255,0) 100%
          );
        }

        .pdh-topbar,
        .pdh-main,
        .pdh-divider {
          position: relative;
          z-index: 1;
        }

        .pdh-topbar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 18px;
          margin-bottom: 14px;
        }

        .pdh-brand {
          display: flex;
          align-items: center;
          gap: 14px;
          min-width: 0;
        }
        .pdh-action-btn-small {
  min-width: 46px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
        .pdh-logo {
          width: 44px;
          height: 44px;
          object-fit: contain;
          display: block;
          flex-shrink: 0;
          filter: drop-shadow(0 8px 18px rgba(38,96,255,0.28));
        }

        .pdh-brand-texts h1 {
          margin: 0;
          color: #f4f7ff;
          font-size: 18px;
          font-weight: 700;
          line-height: 1.1;
        }

        .pdh-brand-texts p {
          margin: 6px 0 0;
          color: #93a7d8;
          font-size: 11px;
          letter-spacing: 1px;
          text-transform: uppercase;
          line-height: 1.15;
        }

        .pdh-top-actions {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: nowrap;
          flex-shrink: 0;
        }

        .pdh-nav-pill {
          display: flex;
          align-items: center;
          gap: 14px;
          height: 38px;
          padding: 0 14px;
          border-radius: 12px;
          border: 1px solid rgba(255,255,255,0.08);
          background: rgba(255,255,255,0.03);
          color: #d7e1ff;
          font-size: 13px;
          white-space: nowrap;
        }

        .pdh-nav-pill .active {
          color: #60e08d;
          font-weight: 700;
        }

        .pdh-nav-caret {
          opacity: 0.9;
        }

        .pdh-icon-btn {
          width: 38px;
          height: 38px;
          border-radius: 10px;
          border: 1px solid rgba(255,255,255,0.08);
          background: rgba(255,255,255,0.03);
          color: #dce4ff;
          cursor: pointer;
          flex-shrink: 0;
        }

        .pdh-divider {
          height: 1px;
          background: rgba(255,255,255,0.08);
          margin-bottom: 16px;
        }

        .pdh-main {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 20px;
        }

        .pdh-left {
          flex: 1;
          min-width: 280px;
          padding-top: 2px;
        }

        .pdh-left h2 {
          margin: 0 0 12px;
          color: #ffffff;
          font-size: 31px;
          font-weight: 600;
          line-height: 1.12;
          letter-spacing: -0.2px;
        }

        .pdh-subline,
        .pdh-meta-line,
        .pdh-producer-line {
          color: #dfe6ff;
          font-size: 16px;
          line-height: 1.42;
          margin-bottom: 10px;
        }

        .pdh-producer-line {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .pdh-status {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 34px;
          padding: 0 14px;
          border-radius: 999px;
          background: rgba(78, 178, 108, 0.22);
          color: #eafff0;
          font-size: 14px;
          font-weight: 700;
          border: 1px solid rgba(92,180,116,0.35);
        }

        .pdh-meta-line {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }

        .pdh-reference-line {
          margin-bottom: 0;
        }

        .pdh-meta-line strong {
          color: #ffffff;
          font-weight: 700;
        }

        .pdh-flag-img {
          width: 24px;
          height: 16px;
          object-fit: cover;
          border-radius: 2px;
          display: inline-block;
          box-shadow: 0 0 0 1px rgba(255,255,255,0.08);
        }

        .pdh-right {
          width: auto;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 10px;
          flex-wrap: nowrap;
          padding-top: 4px;
          flex-shrink: 0;
        }

        .pdh-action-btn {
          height: 40px;
          padding: 0 18px;
          border-radius: 10px;
          border: 1px solid rgba(255,255,255,0.08);
          background: rgba(255,255,255,0.04);
          color: #e7edff;
          font-size: 14px;
          cursor: pointer;
          white-space: nowrap;
          flex-shrink: 0;
        }

        .pdh-action-btn-small {
          min-width: 46px;
          padding: 0 14px;
          text-align: center;
        }

        @media (max-width: 1100px) {
          .pdh-main {
            flex-direction: column;
          }

          .pdh-right {
            width: 100%;
            justify-content: flex-start;
            padding-top: 0;
            flex-wrap: wrap;
          }
        }

        @media (max-width: 760px) {
          .pdh-header {
            padding: 16px;
            border-radius: 18px;
          }

          .pdh-topbar {
            flex-direction: column;
            align-items: flex-start;
          }

          .pdh-brand-texts h1 {
            font-size: 17px;
          }

          .pdh-left h2 {
            font-size: 28px;
          }

          .pdh-subline,
          .pdh-meta-line,
          .pdh-producer-line {
            font-size: 15px;
          }

          .pdh-right {
            width: 100%;
            flex-wrap: wrap;
          }

          .pdh-action-btn,
          .pdh-action-btn-small {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
}